import { post } from '@/utils/ApiUtil';
import type { InviteTeamMemberParamDTO, TeamDetailDTO } from './TeamMembersType';

export const TeamMembersApi = {
  getTeamDetail: async (): Promise<TeamDetailDTO | null> => {
    const result = await post<null, TeamDetailDTO>('/sparrowTeam/getTeamDetail', null);
    if (typeof result === 'string') {
      return null;
    }
    return result;
  },

  inviteMember: async (params: InviteTeamMemberParamDTO): Promise<boolean> => {
    const result = await post<InviteTeamMemberParamDTO, boolean>('/sparrowTeam/teamInviteMember', params);
    if (typeof result === 'string') {
      return false;
    }
    return !!result;
  },

  removeMember: async (sellerId: string): Promise<boolean> => {
    const result = await post<{ sellerId: string }, boolean>('/sparrowTeam/teamDeleteUser', { sellerId });
    if (typeof result === 'string') {
      return false;
    }
    return !!result;
  },
};
